export const US_CITIZEN_VALUE = "U.S. Citizen or U.S. National"
export const US_DUAL_CITIZEN_VALUE = "U.S. Dual Citizen"
export const US_PERMANENT_RESIDENT_VALUE = "U.S. Permanent Resident"
export const US_REFUGEE_OR_ASYLEE_VALUE = "U.S. Refugee or Asylee"
export const DACA_OR_UNDOCUMENTED_VALUE =
  "DACA, Undocumented, Deferred Enforced Departure, or Temporary Protected Status"
const CITIZEN_OF_NON_US_COUNTRY_VALUE = "Citizen of Non-U.S. Country"

export const UNDEFINED_OR_US_CITIZEN_VALUE = ["", US_CITIZEN_VALUE] as const

export const US_DUAL_CITIZEN_VALUES = [
  US_DUAL_CITIZEN_VALUE,
  US_PERMANENT_RESIDENT_VALUE,
] as const

export const NON_US_CITIZEN_VALUES = [
  US_REFUGEE_OR_ASYLEE_VALUE,
  DACA_OR_UNDOCUMENTED_VALUE,
  CITIZEN_OF_NON_US_COUNTRY_VALUE,
] as const

export const ALL_CITIZENSHIP_VALUES = [
  US_CITIZEN_VALUE,
  US_DUAL_CITIZEN_VALUE,
  US_PERMANENT_RESIDENT_VALUE,
  US_REFUGEE_OR_ASYLEE_VALUE,
  DACA_OR_UNDOCUMENTED_VALUE,
  CITIZEN_OF_NON_US_COUNTRY_VALUE,
]
